<template>
  <li class="relative cursor-pointer">
    <div v-if="!visible" class="flex justify-between w-full" @click="open">
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot name="accordion-trigger" />
    </div>
    <div
      v-else
      @click="open"
      class="flex justify-between w-full accordion__trigger_active"
    >
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot name="accordion-close-trigger" />
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div v-show="visible" class="accordion__content">
        <ul>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <slot name="accordion-content" />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script setup>
const props = {
  activeIndex: {
    type: [Number, Boolean],
    default: null,
    required: false,
  },
};

const nuxtApp = useNuxtApp();
const index = ref(null);

const visible = computed(() => {
  return nuxtApp.$Accordion.active.includes(index.value);
});

onBeforeMount(() => {
  index.value = nuxtApp.$Accordion.count++;
  if (props.activeIndex >= 0 && props.activeIndex != null) {
    nuxtApp.$Accordion.active.push(props.activeIndex);
  }
});

function open() {
  if (visible && nuxtApp.$Accordion.active.length == 1) {
    nuxtApp.$Accordion.active = [];
  } else {
    nuxtApp.$Accordion.active = [index.value];
  }
}

function start(el) {
  el.style.height = el.scrollHeight + "px";
}

function end(el) {
  el.style.height = "";
}
</script>

<style scoped>
.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.2s ease, opacity 0.2s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
